<div
  class="inline-edit-cell"
  [class.is-editing]="isEditing"
  [class.hover-edit]="showEditOnHover"
  [class.numeric-edit]="fieldType.toLowerCase() === 'number'"
  (pointerdown)="$event.stopPropagation()"
  (click)="$event.stopPropagation()"
  (keydown)="$event.stopPropagation()"
>
  <ng-container *ngIf="!isEditing; else editMode">
    <ng-container *ngIf="displayAsTextbox; else displayMode">
      <kendo-textbox
        class="inline-edit-display w-100"
        [readonly]="true"
        [value]="value"
        [placeholder]="placeholder"
      ></kendo-textbox>
    </ng-container>
    <ng-template #displayMode>
      <ng-container *ngIf="displayAsDxTextbox; else textMode">
        <dx-text-box
          class="inline-edit-display"
          [readOnly]="true"
          [value]="value"
          [placeholder]="placeholder"
        ></dx-text-box>
      </ng-container>
      <ng-template #textMode>
        <span class="inline-edit-value" [title]="displayValue">{{ displayValue }}</span>
      </ng-template>
    </ng-template>
    <button
      mat-icon-button
      type="button"
      class="inline-edit-action inline-edit-trigger"
      (click)="startEdit()"
      [disabled]="!canEdit"
      aria-label="Edit"
    >
      <mat-icon>edit</mat-icon>
    </button>
  </ng-container>

  <ng-template #editMode>
    <ng-container *ngIf="displayAsTextbox; else dxEditMode">
      <kendo-textbox
        class="inline-edit-input w-100"
        [(ngModel)]="draftValue"
        [placeholder]="placeholder"
        [disabled]="isSaving"
        (keydown.enter)="save()"
        (keydown)="onKeyDown($event)"
      ></kendo-textbox>
    </ng-container>
    <ng-template #dxEditMode>
      <ng-container *ngIf="useSelectEditor; else primitiveDxEditMode">
        <div class="inline-edit-combo inline-edit-input">
          <input
            matInput
            #selectTrigger="matAutocompleteTrigger"
            [matAutocomplete]="selectOptions"
            [type]="fieldType.toLowerCase() === 'number' ? 'number' : 'text'"
            [ngModel]="draftValue"
            (ngModelChange)="onSelectDraftChanged($event)"
            [attr.min]="minNumber"
            [placeholder]="placeholder"
            [disabled]="isSaving"
            (keydown.enter)="save()"
            (keydown)="onKeyDown($event)"
          />
          <button
            mat-icon-button
            type="button"
            class="inline-edit-dropdown"
            [disabled]="isSaving || isLoadingOptions"
            (mousedown)="$event.preventDefault()"
            (click)="openSelectOptions(selectTrigger)"
            aria-label="Show available values"
          >
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
          <mat-autocomplete #selectOptions="matAutocomplete">
            <mat-option
              *ngFor="let option of filteredEditorOptions"
              [value]="getSelectOptionValue(option)"
            >
              {{ getSelectOptionLabel(option) }}
            </mat-option>
          </mat-autocomplete>
        </div>
      </ng-container>
      <ng-template #primitiveDxEditMode>
        <ng-container *ngIf="fieldType.toLowerCase() === 'number'; else dxTextEditMode">
          <dx-number-box
            class="inline-edit-input"
            [(value)]="draftValue"
            [placeholder]="placeholder"
            [showClearButton]="showClearButton"
            [disabled]="isSaving"
            [min]="minNumber"
            (onEnterKey)="save()"
            (onKeyDown)="onKeyDown($event)"
          ></dx-number-box>
        </ng-container>
        <ng-template #dxTextEditMode>
          <dx-text-box
            class="inline-edit-input"
            [(value)]="draftValue"
            [placeholder]="placeholder"
            [showClearButton]="showClearButton"
            [disabled]="isSaving"
            (onEnterKey)="save()"
            (onKeyDown)="onKeyDown($event)"
          ></dx-text-box>
        </ng-template>
      </ng-template>
    </ng-template>
    <button
      mat-icon-button
      type="button"
      class="inline-edit-action"
      (click)="save()"
      [disabled]="isSaving"
      aria-label="Save"
    >
      <mat-icon>check</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      class="inline-edit-action"
      (click)="cancelEdit()"
      [disabled]="isSaving"
      aria-label="Cancel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </ng-template>
</div>
